export default function Footer() {
  return (
    <footer className="bg-[#111] text-[#F6F6F2] py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          <div>
            <p className="font-head font-extrabold tracking-tighter text-4xl">OUTDOEM<span className="text-[#005CEE]">.</span></p>
            <p className="mt-3 text-[#94A3B8] max-w-sm text-sm leading-relaxed">
              OutDoEm Maintenance Services — precision interior painting, priced honestly at $1.80 per square foot.
            </p>
          </div>
          <div className="font-mono2 text-sm text-[#94A3B8] space-y-2">
            <p>bookings@outdoem.com</p>
            <p>Mon–Sat · 8am–6pm</p>
            <p className="text-[#FF4500]">Free on-site estimates</p>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-xs text-[#94A3B8] font-mono2">
          <span>© {new Date().getFullYear()} OUTDOEM MAINTENANCE SERVICES</span>
          <span>PRECISION CRAFT · PREMIUM FINISH</span>
        </div>
      </div>
    </footer>
  );
}
